import {connect} from '@modifi/redux'
import {COMPANY_CIN_CODE} from '@modifi/plugin-onboarding'

import DataSourceWizard, {DataSourceWizardProps} from './DataSourceWizard'
import {
  selectCompanyName,
  selectCurrentCompaniesCountryCode,
  selectCompanyExternalId,
} from '../../../data/company'
import {selectInputFieldByName, selectInputFieldsAreLoading} from '../../../data/input-fields'
import {
  selectProviderDetails,
  selectPublicRegisteredCompaniesAreLoading,
  selectPublicRegisteredCompanyIsLoading,
  selectPublicRegisteredCompanyLegalRepresentatives,
  selectPublicRegisteredCompanyUltimateBeneficialOwners,
} from '../../../data/public-registered-companies'
import {
  selectCompanyRegistrationIsLoading,
  selectCompanyCinCode,
} from '../../../data/company-registration'
import {
  selectInitialFormData,
  aInitializePage,
  aSubmit,
  aSkip,
  selectUpdatePending,
  selectUpdateHasError,
} from './store'

const mapStateToProps = (
  state: Record<string, any>
): Pick<
  DataSourceWizardProps,
  | 'countryCode'
  | 'initialFormData'
  | 'sourcesAreLoading'
  | 'legalRepresentativesOfSelectedSource'
  | 'ultimateBeneficialOwnersOfSelectedSource'
  | 'providerDetails'
  | 'selectedDataSourceDetailsAreLoading'
  | 'submitPending'
  | 'hasError'
> => {
  const countryCode = selectCurrentCompaniesCountryCode(state)
  const companyName = selectCompanyName(state)
  const hasCinCodeInputField = !!selectInputFieldByName(state, COMPANY_CIN_CODE)
  const externalCompanyId = selectCompanyExternalId(state)
  const isInputFieldsLoading = selectInputFieldsAreLoading(state)
  const cinCode = selectCompanyCinCode(state)

  const getAreSourcesLoading = (): boolean => {
    if (hasCinCodeInputField && externalCompanyId && !isInputFieldsLoading) {
      if (!cinCode) {
        return selectCompanyRegistrationIsLoading(state)
      }
      return selectPublicRegisteredCompanyIsLoading(state)
    }
    if (countryCode && companyName && !hasCinCodeInputField && !isInputFieldsLoading) {
      return selectPublicRegisteredCompaniesAreLoading(state)
    }
    return true
  }

  return {
    countryCode,
    initialFormData: selectInitialFormData(state),
    sourcesAreLoading: getAreSourcesLoading(),
    legalRepresentativesOfSelectedSource: selectPublicRegisteredCompanyLegalRepresentatives(state),
    ultimateBeneficialOwnersOfSelectedSource:
      selectPublicRegisteredCompanyUltimateBeneficialOwners(state),
    providerDetails: selectProviderDetails(state),
    selectedDataSourceDetailsAreLoading: selectPublicRegisteredCompanyIsLoading(state),
    submitPending: selectUpdatePending(state),
    hasError: selectUpdateHasError(state),
  }
}

const mapDispatchToProps = {
  initialize: aInitializePage,
  submit: aSubmit,
  skip: aSkip,
}

export default connect(mapStateToProps, mapDispatchToProps)(DataSourceWizard)
